import React from 'react';
import { AlertTriangle, Scale, MessageSquare, Zap } from 'lucide-react';
import './ProblemSection.css';

const ProblemSection = () => {
  const problems = [
    { icon: MessageSquare, text: 'AI-generated posts may misrepresent company policy' },
    { icon: Scale, text: 'Statements may create legal or regulatory exposure' },
    { icon: AlertTriangle, text: 'Messaging can conflict with leadership strategy' },
    { icon: Zap, text: 'Communication errors spread publicly in seconds' },
  ];

  return (
    <section className="problem-section section" data-testid="problem-section">
      <div className="container">
        <div className="problem-content">
          <h2 className="problem-title" data-testid="problem-title">
            AI Accelerates Communication.<br />
            <span className="highlight">It Also Accelerates Risk.</span>
          </h2>
          
          <div className="problem-grid">
            {problems.map((problem, index) => (
              <div key={index} className="problem-item" data-testid={`problem-item-${index}`}>
                <div className="problem-icon-wrapper">
                  <problem.icon size={22} className="problem-icon" />
                </div>
                <p className="problem-text">{problem.text}</p>
              </div>
            ))}
          </div>
          
          <p className="problem-conclusion" data-testid="problem-conclusion">
            Without governance, AI amplifies reputational risk.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
